'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./fields.css');

var _ = require('../../');

var _field = require('./field');

var _field2 = _interopRequireDefault(_field);

var _models = require('../../models');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeckoFields = function (_Component) {
    _inherits(GeckoFields, _Component);

    function GeckoFields() {
        _classCallCheck(this, GeckoFields);

        return _possibleConstructorReturn(this, (GeckoFields.__proto__ || Object.getPrototypeOf(GeckoFields)).apply(this, arguments));
    }

    _createClass(GeckoFields, [{
        key: 'isHidden',


        // Check if field should be hidden
        value: function isHidden(field) {
            return field.hideWhen ? field.hideWhen() : false;
        }
    }, {
        key: 'renderClasses',
        value: function renderClasses(field) {
            return _.GECKO_UTILS.classNames(_defineProperty({
                'form-group col-12': true
            }, field.class, field.class));
        }
    }, {
        key: 'renderStyles',
        value: function renderStyles(field) {
            var styles = {};

            // Add field width
            if (field.width) styles['flex'] = '0 0 ' + field.width;
            // Add default width
            if (!field.width) styles['flex'] = '0 0 50%';
            // Break onto new line (ALLAN INSISTED ON FLEXBOX AND THIS NO LONGER WORKS!!!)
            //if (field.break) styles['clear'] = 'both';
            return styles;
        }
    }, {
        key: 'renderField',
        value: function renderField(field, i) {
            if (!this.isHidden(field)) {
                return _react2.default.createElement(
                    'div',
                    { className: this.renderClasses(field), style: this.renderStyles(field), key: i },
                    _react2.default.createElement(_field2.default, { field: field, values: this.props.values, handler: this.props.handler.bind(this) })
                );
            }
            return null;
        }
    }, {
        key: 'submitForm',
        value: function submitForm(event) {
            // Stop the form from reloading the page
            event.preventDefault();
            // Fire custom submit handler
            return this.props.submitHandler();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'form',
                { className: 'gecko-ui-fields', onSubmit: this.submitForm.bind(this) },
                this.props.fields.map(function (field, i) {
                    return _this2.renderField(field, i);
                }),
                _react2.default.createElement('input', { className: 'gecko-ui-submit-input', type: 'submit', value: '#' })
            );
        }
    }]);

    return GeckoFields;
}(_react.Component);

GeckoFields.defaultProps = {
    fields: [],
    values: {},
    handler: function handler() {},
    submitHandler: function submitHandler() {}
};

GeckoFields.propTypes = {
    fields: _models.GeckoFieldsModel.isRequired,
    values: _propTypes2.default.object,
    handler: _propTypes2.default.func,
    submitHandler: _propTypes2.default.func
};

exports.default = GeckoFields;